export default __webpack_public_path__ + "static/media/sample_test_taking_2.ec40a882.png";